import { addNotification } from "../../../actions";
import Modal from "../../../controls/Modal";
import Spinner from "../../../controls/Spinner";
import { IconButton } from "../../../controls/TooltipControls";
import { WebviewEmbed, WebviewOverlay } from "../../../controls/Webview";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import Debouncer from "../../../util/Debouncer";
import { log } from "../../../util/log";
import { truthy } from "../../../util/util";
import { Notification } from "../../../views/Notification";
import { closeBrowser } from "../actions";
import PromiseBB from "bluebird";
import { clipboard } from "electron";
import * as _ from "lodash";
import * as React from "react";
import { Breadcrumb, Button } from "react-bootstrap";
import * as ReactDOM from "react-dom";
import * as nodeUrl from "url";
import { getErrorMessageOrDefault } from "@vortex/shared";
function nop() {
    return null;
}
class BrowserView extends ComponentEx {
    mRef;
    mWebView = null;
    mCallbacks;
    mSessionCallbacks;
    mLoadingDebouncer;
    mUpdateTimer = undefined;
    mMounted = false;
    mCurrentUrl;
    constructor(props) {
        super(props);
        this.initState({
            confirmed: false,
            loading: false,
            url: props.url,
            history: [props.url],
            historyIdx: 0,
            opened: 0,
            filtered: [],
        });
        this.mCurrentUrl = props.url;
        this.mLoadingDebouncer = new Debouncer((loading) => {
            if (loading !== this.state.loading) {
                this.nextState.loading = loading;
            }
            return PromiseBB.resolve();
        }, 100, false);
        this.mCallbacks = {
            "did-finish-load": () => {
                const newUrl = this.mCurrentUrl;
                this.nextState.url = newUrl;
                this.props.onEvent(this.props.subscriber, "navigate", newUrl);
                if (newUrl !== this.nextState.history[this.nextState.historyIdx]) {
                    this.nextState.history.splice(this.nextState.historyIdx + 1, 9999, newUrl);
                    ++this.nextState.historyIdx;
                }
            },
            "did-navigate": (evt) => {
                this.mCurrentUrl = typeof evt === "string" ? evt : evt.url;
                this.navigate(this.mCurrentUrl);
            },
            "did-navigate-in-page": (evt) => {
                this.mCurrentUrl = typeof evt === "string" ? evt : evt.url;
                this.navigate(this.mCurrentUrl);
            },
        };
    }
    componentDidMount() {
        this.updateFiltered();
        this.mMounted = true;
    }
    componentWillUnmount() {
        this.mMounted = false;
        if (this.mUpdateTimer !== undefined) {
            clearTimeout(this.mUpdateTimer);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.notifications !== this.props.notifications) {
            this.updateFiltered();
        }
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.url !== this.props.url) {
            if (newProps.url === undefined ||
                this.props.url === undefined ||
                new URL(newProps.url).hostname !== new URL(this.props.url).hostname) {
                this.nextState.confirmed = false;
                this.nextState.opened = Date.now();
                if (newProps.url !== undefined) {
                    this.nextState.history = [newProps.url];
                    this.nextState.historyIdx = 0;
                }
            }
            this.nextState.url = this.mCurrentUrl = newProps.url;
        }
    }
    shouldComponentUpdate(newProps, newState) {
        const res = this.props.url !== newProps.url ||
            this.props.instructions !== newProps.instructions ||
            this.props.notifications !== newProps.notifications ||
            this.state.url !== newState.url ||
            this.state.loading !== newState.loading ||
            this.state.confirmed !== newState.confirmed ||
            this.state.history !== newState.history ||
            this.state.historyIdx !== newState.historyIdx ||
            this.state.filtered !== newState.filtered;
        return res;
    }
    render() {
        const { t, overlay, instructions, skippable } = this.props;
        const { confirmed, filtered, history, historyIdx, loading, url } = this.state;
        const referrer = history.length > 0 ? history[historyIdx - 1] : undefined;
        const Webview = overlay ? WebviewOverlay : WebviewEmbed;
        return (React.createElement(Modal, { id: "browser-dialog", show: url !== undefined, onHide: nop },
            React.createElement(Modal.Header, null,
                this.renderNav(),
                this.renderUrl(history[historyIdx]),
                loading ? React.createElement(Spinner, null) : null,
                React.createElement(IconButton, { icon: "clipboard", tooltip: t("Copy URL to clipboard"), onClick: this.copyUrlToClipboard })),
            React.createElement(Modal.Body, null,
                instructions !== undefined ? (React.createElement("p", { id: "browser-instructions" }, instructions)) : null,
                confirmed ? (React.createElement(Webview, { id: "browser-webview", src: url, ref: this.setRef, httpreferrer: referrer, onLoading: this.loading, onNewWindow: this.newWindow, events: this.mCallbacks })) : (this.renderConfirm()),
                React.createElement("div", { className: "browser-notifications" }, filtered.map(this.renderNotification))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: this.close }, t("Cancel")),
                skippable ? React.createElement(Button, { onClick: this.skip }, t("Skip")) : null)));
    }
    renderNotification = (notification, idx) => {
        const { t } = this.props;
        const translated = { ...notification };
        translated.title =
            translated.title !== undefined &&
                (notification.localize === undefined ||
                    notification.localize.title !== false)
                ? t(translated.title, { replace: translated.replace })
                : translated.title;
        translated.message =
            notification.localize === undefined ||
                notification.localize.message !== false
                ? t(translated.message, { replace: translated.replace })
                : translated.message;
        return React.createElement(Notification, { key: idx, collapsed: 1, params: translated });
    };
    renderLoadingOverlay() {
        return (React.createElement("div", { className: "browser-loading" },
            React.createElement(Spinner, null)));
    }
    renderNav() {
        const { t } = this.props;
        const { history, historyIdx } = this.state;
        return (React.createElement("div", null,
            React.createElement(IconButton, { icon: "nav-back", onClick: this.navBack, disabled: historyIdx === 0, tooltip: t("Back") }),
            React.createElement(IconButton, { icon: "nav-forward", onClick: this.navForward, disabled: historyIdx === history.length - 1, tooltip: t("Forward") })));
    }
    renderUrl(input) {
        if (!truthy(input)) {
            return null;
        }
        const parsed = nodeUrl.parse(input);
        const segments = (parsed.pathname ?? "")
            .split("/")
            .filter((seg) => seg.length > 0);
        const Item = Breadcrumb.Item;
        return (React.createElement(Breadcrumb, null,
            React.createElement(Item, { "data-idx": -1, onClick: this.navCrumb },
                parsed.protocol,
                "//",
                parsed.hostname),
            segments.map((seg, idx) => (React.createElement(Item, { "data-idx": idx, key: `${idx}-${seg}`, onClick: this.navCrumb, active: idx === segments.length - 1 }, seg))),
            React.createElement(Item, { active: true }, parsed.search)));
    }
    copyUrlToClipboard = () => {
        clipboard.writeText(this.props.url ?? "");
    };
    renderConfirm() {
        const { t, url } = this.props;
        return (React.createElement("div", null,
            React.createElement("h3", null, t("Attention")),
            React.createElement("p", null, t("Vortex is about to open an external web page:")),
            React.createElement("a", { href: "#" }, url),
            React.createElement("p", null, t("Please be aware that Vortex is based on Electron which in turn is based on " +
                "Chrome, but it will not always be the newest version. Also, we can't rule out " +
                "that electron might contain it's own security issues pertaining to website " +
                "access.")),
            React.createElement("p", null, t("If you have security concerns or don't fully trust this page, please don't " +
                "continue. Don't navigate away from pages you don't trust.")),
            React.createElement(Button, { onClick: this.confirm }, t("Continue"))));
    }
    displayTime = (item) => {
        if (item.displayMS !== undefined) {
            return item.displayMS;
        }
        return ({
            warning: 10000,
            error: 10000,
            success: 5000,
            info: 5000,
            activity: null,
        }[item.type] || 5000);
    };
    updateFiltered() {
        const { notifications } = this.props;
        const { opened } = this.state;
        this.mUpdateTimer = undefined;
        if (!this.mMounted) {
            return;
        }
        const now = Date.now();
        const filtered = notifications.filter((item) => {
            if (["activity", "silent"].includes(item.type) ||
                item.createdTime < opened) {
                return false;
            }
            const displayTime = this.displayTime(item);
            return displayTime === null || item.createdTime + displayTime > now;
        });
        if (!_.isEqual(this.state.filtered, filtered)) {
            this.nextState.filtered = filtered;
        }
        if (filtered.length > 0) {
            if (this.mUpdateTimer !== undefined) {
                // should never happen
                clearTimeout(this.mUpdateTimer);
            }
            this.mUpdateTimer = setTimeout(() => this.updateFiltered(), 1000);
        }
    }
    loading = (loading) => {
        if (loading) {
            this.mLoadingDebouncer.schedule(undefined, true);
        }
        else {
            this.mLoadingDebouncer.runNow(undefined, false);
        }
    };
    newWindow = (newUrl, disposition) => {
        const { onEvent, subscriber } = this.props;
        const urlParsed = nodeUrl.parse(newUrl);
        if (urlParsed.hostname === "drive.google.com") {
            this.nextState.url = newUrl;
            return;
        }
        // currently we try to download any url that isn't opened in the same window
        const res = onEvent(subscriber, "download-url", newUrl);
        if (res === "close") {
            this.props.onClose();
        }
        else if (res === "continue") {
            // no handler for download-url? Then lets try to open the link
            this.nextState.url = newUrl;
        }
    };
    setRef = (ref) => {
        this.mRef = ref;
        if (ref !== null) {
            this.mWebView = ReactDOM.findDOMNode(this.mRef);
            if (truthy(this.mWebView)) {
                Object.keys(this.mCallbacks).forEach((event) => {
                    this.mWebView.addEventListener(event, this.mCallbacks[event]);
                });
            }
        }
        else {
            if (truthy(this.mWebView)) {
                Object.keys(this.mCallbacks).forEach((event) => {
                    this.mWebView.removeEventListener(event, this.mCallbacks[event]);
                });
            }
        }
    };
    navBack = () => {
        const { history, historyIdx } = this.state;
        const newPos = Math.max(0, historyIdx - 1);
        this.nextState.historyIdx = newPos;
        // this.nextState.url = history[newPos];
        if (truthy(this.mWebView)) {
            try {
                this.mRef.loadURL(history[newPos]);
            }
            catch (err) {
                log("warn", "failed to navigate", {
                    url: history[newPos],
                    error: getErrorMessageOrDefault(err),
                });
            }
        }
    };
    navForward = () => {
        const { history, historyIdx } = this.state;
        const newPos = Math.min(history.length - 1, historyIdx + 1);
        this.nextState.historyIdx = newPos;
        // this.nextState.url = history[newPos];
        if (truthy(this.mWebView)) {
            try {
                this.mRef.loadURL(history[newPos]);
            }
            catch (err) {
                log("warn", "failed to navigate", {
                    url: history[newPos],
                    error: getErrorMessageOrDefault(err),
                });
            }
        }
    };
    navCrumb = (evt) => {
        if (!truthy(this.mWebView) || !truthy(this.mCurrentUrl)) {
            return;
        }
        const idx = parseInt(evt.currentTarget.getAttribute("data-idx"), 10);
        // const parsed = nodeUrl.parse(this.mWebView.getURL());
        const parsed = nodeUrl.parse(this.mCurrentUrl);
        parsed.pathname = (parsed.pathname ?? "")
            .split("/")
            .slice(0, idx + 2)
            .join("/");
        parsed.path = undefined;
        parsed.href = undefined;
        parsed.search = undefined;
        const nextUrl = nodeUrl.format(parsed);
        this.addToHistory(nextUrl);
        try {
            this.mRef.loadURL(nextUrl);
        }
        catch (err) {
            log("warn", "failed to navigate", {
                url: nextUrl,
                error: getErrorMessageOrDefault(err),
            });
        }
    };
    confirm = () => {
        this.nextState.confirmed = true;
    };
    sanitised(input) {
        const parsed = nodeUrl.parse(input);
        parsed.hash = null;
        parsed.search = null;
        parsed.query = null;
        return nodeUrl.format(parsed);
    }
    addToHistory(url) {
        url = url.replace(/[\/]*$/, "");
        if (url !== this.nextState.history[this.nextState.historyIdx]) {
            this.nextState.history.splice(this.nextState.historyIdx + 1, 9999, url);
            ++this.nextState.historyIdx;
        }
    }
    navigate(url) {
        if (this.sanitised(url) === this.sanitised(this.state.url)) {
            // don't do anything if just the hash changed
            return;
        }
        // this.nextState.url = url;
        this.addToHistory(url);
        this.props.onNavigate(url);
    }
    skip = () => {
        const { onClose, onEvent, subscriber } = this.props;
        if (onEvent(subscriber, "close", true) !== "ignore") {
            onClose();
        }
    };
    close = () => {
        const { onClose, onEvent, subscriber } = this.props;
        if (onEvent(subscriber, "close", false) !== "ignore") {
            onClose();
        }
    };
}
const emptyList = [];
function mapStateToProps(state) {
    return {
        subscriber: state.session.browser.subscriber || undefined,
        instructions: state.session.browser.instructions || undefined,
        url: state.session.browser.url || undefined,
        skippable: state.session.browser.skippable || undefined,
        notifications: state.session.notifications.notifications || emptyList,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onClose: () => dispatch(closeBrowser()),
        onNotification: (notification) => dispatch(addNotification(notification)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(BrowserView));
